import { useState, useEffect } from 'react';
import { SubscriptionState } from '../App/useSubscription';

export const useSubscriptionStatus = (
  subscription: SubscriptionState
) => {

  const [isNoProduct, setIsNoProduct] = useState<boolean>(false);
  const [isPaused, setIsPaused] = useState<boolean>(false);
  const [isPreviousMember, setIsPreviousMember] =  useState<boolean>(false); //

  useEffect(() => {
    if (!subscription) return;
    const noProduct = subscription.subscriptionLines.length === 0;
    const paused = subscription.status === 'PAUSED';
    setIsNoProduct(noProduct);
    setIsPaused(paused);
    setIsPreviousMember(noProduct && paused);
  }, [subscription]);

  return {
    isNoProduct,
    isPaused,
    isPreviousMember
  };
}